import { getIndexExploreContextUrl } from '../utils/utils'
import useFullscreenState from './useFullscreenState'

/**
 * Custom hook to determine if the Zion Root header is hidden
 * The header is hidden when:
 * 1. User came from Index/Explore context (contextUrl exists)
 * 2. Document is in fullscreen mode
 *
 * This matches the logic in RootBase.js for header visibility
 *
 * @returns {boolean} True if the header is hidden, false if visible
 */
export default function useIsHeaderHidden() {
  const contextUrl = getIndexExploreContextUrl()
  const [isFullScreen] = useFullscreenState()

  return Boolean(contextUrl) || isFullScreen
}
